import React from 'react';

const BCEconomicSectorFormModal = React.lazy(() => import('../components/FormModal'));
const bCEconomicSectorModalRegistry = {
    company_bcEconomicSectorId: BCEconomicSectorFormModal
};
export default bCEconomicSectorModalRegistry;
